export const MAIN = '/';
export const LOGIN = '/login';
export const HOME = '/home';
export const ACCESS = '/acceso';

